export default function AtcSearchCriteriaGroupItemService() {
    Object.assign(this, {
        setSelectedFrequentFlight,
        getFrequentFlightView,
    });

    const allAirportsLabel = 'All Airports';

    function setSelectedFrequentFlight(model, field, viewModel) {
        return function(flight) {
            viewModel.$setValidity('editable', true);
            const name = flight.CityName + ', ' + flight.CountryCode;
            const airport = flight.AirportName ? flight.AirportName : allAirportsLabel;
            const Code = flight.AirportCode;
            const DisplayString = name + ' - ' + airport + ' (' + flight.AirportCode + ')';

            model[field] = {
                name,
                airport,
                Code,
                DisplayString,
                IsCity: flight.IsCity,
            };
        };
    }

    function getFrequentFlightView(flight) {
        const airportName = (flight.AirportName)
            ? flight.AirportName
            : allAirportsLabel;

        return _.template('{{cityName}}, {{countryCode}} - {{airportName}} ({{airportCode}})')({
            cityName: flight.CityName,
            countryCode: flight.CountryCode,
            airportName,
            airportCode: flight.AirportCode,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-check-result/search-criteria-group-item/search-criteria-group-item-service.js